// One reading-time rule for every surface. The door, the home and the Edition used to promise
// three different times for the same stories (five, eight and nine minutes). A card is a
// headline, a snippet of about forty words and a why-it-matters line: about forty seconds with
// the swipe. Ten cards is about seven minutes; twelve about eight.
export const SECONDS_PER_CARD = 40;

/** Minutes to read this many cards, never under one. */
export function readMinutes(count) {
  const n = Math.max(0, Number(count) || 0);
  return Math.max(1, Math.round((n * SECONDS_PER_CARD) / 60));
}

/** "about seven minutes" for the prose, "7 min" for a label. */
export function minutesWord(count) {
  const m = readMinutes(count);
  const words = ["", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten", "eleven", "twelve"];
  return `about ${m <= 12 ? words[m] : m} minute${m === 1 ? "" : "s"}`;
}
